"use strict";

exports.__esModule = true;
exports.ticketsDefinition = void 0;
var _react = _interopRequireDefault(require("react"));
var _TicketDetails = require("../../../Ticketing/TicketDetails");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable */

var ticketsDefinition = exports.ticketsDefinition = function ticketsDefinition(translate) {
  return {
    columns: [{
      id: "created",
      name: translate("DataTable.Column.Title.created", "Created At"),
      type: "date",
      usePlantTime: true,
      dateFormat: "ShortDateTime",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "description",
      name: translate("DataTable.Column.Title.description", "Description"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "devices",
      name: translate("DataTable.Column.Title.devices", "Devices"),
      type: "devicesAndGroups",
      canSearch: true,
      canFilter: true,
      showSearchFilter: false
    }, {
      id: "id",
      // if we want to sort by id in the backend, this needs to change to _id and
      // client side filtering needs to be fixed
      sortId: "id",
      name: translate("DataTable.Column.Title.id", "ID"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "links",
      name: translate("DataTable.Column.Title.links", "Links"),
      type: "string",
      canSearch: true,
      canFilter: false
    }, {
      id: "status",
      name: translate("DataTable.Column.Title.status", "Status"),
      type: "status",
      canSearch: true,
      canFilter: true
    }, {
      id: "title",
      name: translate("DataTable.Column.Title.title", "Summary"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "creator",
      name: "Creator",
      type: "creator",
      canSort: false,
      canFilter: true
    }, {
      id: "age",
      sortId: "created",
      name: translate("DataTable.Column.Title.age", "Age"),
      type: "age",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "updated",
      name: translate("DataTable.Column.Title.updated", "Updated At"),
      type: "date",
      usePlantTime: true,
      dateFormat: "ShortDateTime",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "types",
      name: translate("DataTable.Column.Title.types", "Types"),
      type: "ticketTypes",
      canSort: false,
      canFilter: true,
      canSearch: true
    }, {
      id: "assignee",
      name: translate("DataTable.Column.Title.assignee", "Assignee"),
      type: "assignee",
      canSort: false,
      canFilter: true
    }],
    rowFormatters: [{
      id: "status",
      formatter: function formatter(value) {
        if (value && typeof value === "string") {
          if (value.toLocaleLowerCase() === "open") {
            return {
              fontWeight: "600"
            };
          }
          if (value.toLocaleLowerCase() === "closed") {
            return {
              fontStyle: "italic",
              fontWeight: "300"
            };
          }
        }
        return {};
      }
    }],
    SubComponent: function SubComponent(props) {
      var _props$rowData = props.rowData,
        row = _props$rowData.row,
        toggleRowSubComponent = _props$rowData.toggleRowSubComponent,
        nestingPath = _props$rowData.nestingPath,
        width = props.width,
        height = props.height,
        refreshData = props.refreshData;
      var ticketId = row.id;
      return /*#__PURE__*/_react["default"].createElement(_TicketDetails.TicketDetails, {
        ticketId: ticketId,
        width: width,
        height: height,
        refreshData: refreshData,
        onClose: function onClose(e) {
          return toggleRowSubComponent({
            nestingPath: nestingPath
          }, e);
        }
      });
    },
    parseData: function parseData(responseData) {
      var _responseData$history, _responseData$history2;
      var getAge = function getAge(lastUpdate) {
        return lastUpdate - new Date(responseData.created).valueOf();
      };
      var lastItemIndex = ((_responseData$history = responseData.history) == null ? void 0 : _responseData$history.length) - 1;
      responseData.updated = lastItemIndex >= 0 ? (_responseData$history2 = responseData.history[lastItemIndex]) == null ? void 0 : _responseData$history2.timestamp : undefined;
      return {
        created: responseData.created,
        updated: responseData.updated,
        description: responseData.description,
        devices: responseData.devices,
        links: (responseData.links || []).join(", "),
        id: responseData.id,
        status: responseData.status,
        title: responseData.title,
        age: responseData.status === "CLOSED" ? getAge(Date.parse(responseData.updated)) : getAge(Date.now().valueOf()),
        creator: responseData.creatorId,
        assignee: responseData.assigneeId || "",
        types: responseData.type,
        comments: responseData.comments || [],
        priority: responseData.priority
      };
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: false,
        defaultPageSize: "auto",
        columns: [{
          id: "id",
          name: translate("DataTable.Column.Title.id", "ID"),
          type: "string",
          enableSorting: true,
          sortMethod: function sortMethod(a, b) {
            return Number(b) - Number(a);
          }
        }, {
          id: "created",
          name: translate("DataTable.Column.Title.created", "Created At"),
          defaultSortOrder: "DESC",
          // this is to match with the server, without it the server returns it's default forcing a double request to occur
          enableSorting: true,
          type: "date",
          usePlantTime: true,
          dateFormat: "ShortDateTime"
        }, {
          id: "age",
          enableSorting: true,
          name: translate("DataTable.Column.Title.age", "Age"),
          type: "age"
        }, {
          id: "updated",
          name: translate("DataTable.Column.Title.Updated", "Updated At"),
          defaultSortOrder: "DESC",
          enableSorting: true,
          type: "date",
          usePlantTime: true,
          dateFormat: "ShortDateTime"
        }, {
          id: "creator",
          name: translate("DataTable.Column.Title.creator", "Creator"),
          enableSorting: true,
          type: "creator"
        }, {
          id: "types",
          enableSorting: false,
          name: translate("DataTable.Column.Title.types", "Types"),
          type: "ticketTypes"
        }, {
          id: "devices",
          enableSorting: false,
          name: translate("DataTable.Column.Title.devices", "Devices"),
          type: "devicesAndGroups"
        }, {
          id: "title",
          name: translate("DataTable.Column.Title.title", "Summary"),
          enableSorting: true,
          type: "string"
        }, {
          id: "assignee",
          enableSorting: true,
          name: translate("DataTable.Column.Title.assignee", "Assignee"),
          type: "assignee"
        }, {
          id: "status",
          enableSorting: true,
          name: translate("DataTable.Column.Title.status", "Status"),
          type: "status"
        }]
      };
    }
  };
};